import { IonRouterOutlet } from "@ionic/react";
import { ReactNode } from "react";
import { Redirect, Route } from "react-router";

interface Props {
  path: string;
  condition?: boolean;
  children: ReactNode[] | ReactNode;
}

const NestedRoute: React.FC<Props> = ({ path, children, condition }) => {
  return (
    <Route path={path}>
      <IonRouterOutlet>
        {Array.isArray(children)
          ? children.map((c: any, i) => {
              if (condition !== undefined && condition === false)
                return <Redirect exact to="/" key={i} />;

              return (
                <c.type
                  {...c.props}
                  path={path + c.props.path}
                  key={i}
                ></c.type>
              );
            })
          : () => {
              const c = children as any;
              if (condition !== undefined && condition === false)
                return <Redirect exact to="/" />;
              return <c.type {...c.props} path={path + c.props.path}></c.type>;
            }}
        <Redirect exact to="/" />
      </IonRouterOutlet>
    </Route>
  );
};

export default NestedRoute;
